export enum ApplicationFeatureEnum {
  statsdebug = 'statsdebug',
  adsdebug = 'adsdebug',
}
